import api from "@/services/api";
import errorHandler from "@/services/errorHandler";

import { SET_SEARCH_RESULTS, SET_TRACKS } from "@/store/mutation-types";

export default {
  async global({ commit }, keyword = "") {
    try {
      const { payload = {} } = await api.search.global({ q: keyword });
      const { results = null } = payload;

      commit(SET_SEARCH_RESULTS, { results, type: "global" });

      return payload;
    } catch (error) {
      return errorHandler.add(error);
    }
  },
  async tracks({ commit }, keyword = "") {
    try {
      const { payload = {} } = await api.search.tracks({ q: keyword });
      const { results = {} } = payload;
      const tracks = Object.keys(results).map(key => results[key]);

      commit(SET_SEARCH_RESULTS, { results: tracks, type: "tracks" });

      if (tracks.length) {
        commit(`tracks/${SET_TRACKS}`, tracks, { root: true });
      }

      return { tracks };
    } catch (error) {
      return errorHandler.add(error);
    }
  },
  clear({ commit }, type) {
    commit(SET_SEARCH_RESULTS, { type });
  }
};
